import { createAction } from 'redux-actions';
export const SET_SEGMENTS = 'EXCHANGE/SET_SEGMENTS';
export const TOGGLE_SEGMENT = 'EXCHANGE/TOGGLE_SEGMENT';
export const TOGGLE_ALL_SEGMENTS = 'EXCHANGE/TOGGLE_ALL_SEGMENTS';
export const SET_SEGMENT_DATE = 'EXCHANGE/SET_SEGMENT_DATE';
export const CLEAR_SEGMENTS_DATE = 'EXCHANGE/CLEAR_SEGMENTS_DATE';
export const setSegments = createAction(SET_SEGMENTS);
export const setAllSegmentsSelect = createAction(TOGGLE_ALL_SEGMENTS);
export const setSegmentSelect = createAction(TOGGLE_SEGMENT);
export const setSegmentDate = createAction(SET_SEGMENT_DATE);
export const clearSegmentsDate = createAction(CLEAR_SEGMENTS_DATE);
